import axios from "axios";

axios.defaults.baseURL = "https://pdf-gen-1008304377773.asia-southeast2.run.app";

export const SOS = async (data) => {
  const res = await axios.post("/sos/report", data, {
    headers: {
      "Content-Type": "application/json",
    },
  });
  return res.data;
};
